// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(3px);
}

.modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;
    animation: slideUp 0.3s ease;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #e2e8f0;
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
}

.modal-header h2 {
    font-size: 1.5rem;
    color: #1e293b;
    margin: 0;
    flex: 1 1;
}

.close-btn {
    background: none;
    border: none;
    color: #64748B;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.close-btn:hover {
    background: #F1F5F9;
    color: #0F172A;
}

.modal-body {
    padding: 1.5rem;
}

.form-group {
    margin-bottom: 1.25rem;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #334155;
    font-size: 0.95rem;
}

.form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #CBD5E1;
    border-radius: 6px;
    font-size: 15px;
    transition: all 0.2s;
    background: #FFFFFF;
    color: #0F172A;
}

.form-group input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-group input:disabled {
    background: #f8fafc;
    cursor: not-allowed;
}

.form-group input::placeholder {
    color: #94a3b8;
}

.error-message {
    background: #fee2e2;
    color: #dc2626;
    padding: 0.75rem;
    border-radius: 6px;
    margin-bottom: 1rem;
    font-size: 0.875rem;
    border-left: 4px solid #dc2626;
}

.api-response {
    margin-bottom: 1.5rem;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
}

.api-response.success {
    border-color: #10b981;
}

.api-response.error {
    border-color: #ef4444;
}

.response-header {
    padding: 0.75rem;
    font-weight: 600;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

.api-response.success .response-header {
    background: #ecfdf5;
    color: #10b981;
}

.api-response.error .response-header {
    background: #fef2f2;
    color: #ef4444;
}

.response-message {
    padding: 0.75rem;
    border-bottom: 1px solid #e2e8f0;
}

.response-data {
    padding: 0.75rem;
    background: #f8fafc;
}

.response-data pre {
    margin: 0.5rem 0 0 0;
    padding: 0.75rem;
    background: white;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
    font-size: 0.75rem;
    max-height: 200px;
    overflow-y: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
}

.response-note {
    padding: 0.75rem;
    background: #fef3c7;
    color: #92400e;
    font-size: 0.875rem;
    border-top: 1px solid #fde68a;
}

.form-footer {
    margin-top: 2rem;
}

.submit-btn {
    width: 100%;
    padding: 12px;
    background: #2563eb;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.submit-btn:hover:not(:disabled) {
    background: #1d4ed8;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(37, 99, 235, 0.2);
}

.submit-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: white;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.info-text {
    margin-top: 1rem;
    text-align: center;
    color: #64748b;
    font-size: 0.875rem;
    line-height: 1.4;
}

.text-link {
    background: none;
    border: none;
    color: #2563eb;
    text-decoration: underline;
    cursor: pointer;
    font-size: inherit;
    padding: 0;
    transition: color 0.2s;
}

.text-link:hover {
    color: #1d4ed8;
}`, "",{"version":3,"sources":["webpack://./src/components/auth/AuthModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    backdrop-filter: blur(3px);\n}\n\n.modal-content {\n    background: white;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 500px;\n    max-height: 90vh;\n    overflow-y: auto;\n    animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.5rem;\n    border-bottom: 1px solid #e2e8f0;\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 10;\n}\n\n.modal-header h2 {\n    font-size: 1.5rem;\n    color: #1e293b;\n    margin: 0;\n    flex: 1;\n}\n\n.close-btn {\n    background: none;\n    border: none;\n    color: #64748B;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.close-btn:hover {\n    background: #F1F5F9;\n    color: #0F172A;\n}\n\n.modal-body {\n    padding: 1.5rem;\n}\n\n.form-group {\n    margin-bottom: 1.25rem;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    color: #334155;\n    font-size: 0.95rem;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #CBD5E1;\n    border-radius: 6px;\n    font-size: 15px;\n    transition: all 0.2s;\n    background: #FFFFFF;\n    color: #0F172A;\n}\n\n.form-group input:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.form-group input:disabled {\n    background: #f8fafc;\n    cursor: not-allowed;\n}\n\n.form-group input::placeholder {\n    color: #94a3b8;\n}\n\n.error-message {\n    background: #fee2e2;\n    color: #dc2626;\n    padding: 0.75rem;\n    border-radius: 6px;\n    margin-bottom: 1rem;\n    font-size: 0.875rem;\n    border-left: 4px solid #dc2626;\n}\n\n.api-response {\n    margin-bottom: 1.5rem;\n    border-radius: 6px;\n    overflow: hidden;\n    border: 1px solid #e2e8f0;\n}\n\n.api-response.success {\n    border-color: #10b981;\n}\n\n.api-response.error {\n    border-color: #ef4444;\n}\n\n.response-header {\n    padding: 0.75rem;\n    font-weight: 600;\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.api-response.success .response-header {\n    background: #ecfdf5;\n    color: #10b981;\n}\n\n.api-response.error .response-header {\n    background: #fef2f2;\n    color: #ef4444;\n}\n\n.response-message {\n    padding: 0.75rem;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.response-data {\n    padding: 0.75rem;\n    background: #f8fafc;\n}\n\n.response-data pre {\n    margin: 0.5rem 0 0 0;\n    padding: 0.75rem;\n    background: white;\n    border-radius: 4px;\n    border: 1px solid #e2e8f0;\n    font-size: 0.75rem;\n    max-height: 200px;\n    overflow-y: auto;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n}\n\n.response-note {\n    padding: 0.75rem;\n    background: #fef3c7;\n    color: #92400e;\n    font-size: 0.875rem;\n    border-top: 1px solid #fde68a;\n}\n\n.form-footer {\n    margin-top: 2rem;\n}\n\n.submit-btn {\n    width: 100%;\n    padding: 12px;\n    background: #2563eb;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.submit-btn:hover:not(:disabled) {\n    background: #1d4ed8;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(37, 99, 235, 0.2);\n}\n\n.submit-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-radius: 50%;\n    border-top-color: white;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.info-text {\n    margin-top: 1rem;\n    text-align: center;\n    color: #64748b;\n    font-size: 0.875rem;\n    line-height: 1.4;\n}\n\n.text-link {\n    background: none;\n    border: none;\n    color: #2563eb;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: inherit;\n    padding: 0;\n    transition: color 0.2s;\n}\n\n.text-link:hover {\n    color: #1d4ed8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
